import { Box, styled } from '@/shared/ui';

export const StyledSideContainer = styled(Box)(() => ({
  marginLeft: '20px',
  marginTop: '0px',
  marginRight: '40px',
  marginBottom: '0px',
  position: 'sticky',
  top: 0,
  height: '100vh',
  flexShrink: 0,
  overflowY: 'auto',
}));
